"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var moment = require("moment");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var ParBrandsBrandingsListCtl = /** @class */ (function (_super) {
    __extends(ParBrandsBrandingsListCtl, _super);
    function ParBrandsBrandingsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_branding_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.branding_url; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_width = UIUtils_1.UIUtils.IProp2Str(function (o) { o.width; });
        _this.dk_height = UIUtils_1.UIUtils.IProp2Str(function (o) { o.height; });
        _this.dk_header_height = UIUtils_1.UIUtils.IProp2Str(function (o) { o.header_height; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_is_all_country = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_all_country; });
        _this.dk_countries_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.countries_count; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this._errDialog = errDialog;
        return _this;
    }
    ParBrandsBrandingsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    ParBrandsBrandingsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "brand branding with id [" + id + "] not found !";
    };
    ParBrandsBrandingsListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListBrandBrandingsByBrandsGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    branding_url: resp.list[i].branding_url,
                    header_height: resp.list[i].header_height,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    width: resp.list[i].width,
                    height: resp.list[i].height,
                    is_deprecated: resp.list[i].is_deprecated,
                    is_all_country: resp.list[i].is_all_country,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    countries_count: resp.list[i].countries_count,
                    order_number: resp.list[i].order_number
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsBrandingsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandBranding.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                branding_url: data.branding_url,
                header_height: data.header_height,
                width: data.width,
                height: data.height,
                is_deprecated: data.is_deprecated,
                is_all_country: data.is_all_country,
                order_number: data.order_number
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                branding_url: data.branding_url,
                header_height: data.header_height,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                width: data.width,
                height: data.height,
                is_deprecated: data.is_deprecated,
                is_all_country: data.is_all_country,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                title: data.title,
                countries_count: 0,
                order_number: data.order_number
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsBrandingsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandBranding.exec({
                data: {
                    brands_aff_branding_id: data.key,
                    branding_url: data.branding_url,
                    header_height: data.header_height,
                    width: data.width,
                    height: data.height,
                    is_deprecated: data.is_deprecated,
                    is_all_country: data.is_all_country,
                    title: data.title,
                    order_number: data.order_number
                }
            }, function (resp) {
                _tmp.branding_url = data.branding_url;
                _tmp.title = data.title;
                _tmp.header_height = data.header_height;
                _tmp.width = data.width;
                _tmp.height = data.height;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.is_all_country = data.is_all_country;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.order_number = data.order_number;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsBrandingsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    ParBrandsBrandingsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandBranding.exec({ data: { brands_aff_branding_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsBrandingsListCtl.prototype.doSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandBrandingIsDeprecated.exec({ data: { brands_aff_branding_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsBrandingsListCtl.prototype.doSetOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandBrandingPriority.exec({
                data: {
                    brand_partner_branding_id: key,
                    order_number: OrderNumber
                }
            }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return ParBrandsBrandingsListCtl;
}(BaseController_1.BaseController));
exports.ParBrandsBrandingsListCtl = ParBrandsBrandingsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_brandings_list/ctl/ParBrandsBrandingsListCtl.ts
// module id = 953
// module chunks = 0